import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CartRequest, CartResponse, CartSummary } from '../models/cart-item';
import { CheckoutRequest } from '../models/request-data-types';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private baseUrl: string = '/selfcare/cart';

  constructor(private httpClient: HttpClient) { }

  addToCart(cartItem: CartRequest): Observable<CartResponse>{
    return this.httpClient.post<CartResponse>(this.baseUrl, cartItem);
  }

  getCart(): Observable<CartResponse>{
    return this.httpClient.get<CartResponse>(this.baseUrl)
  }

  peekCart(): Observable<CartSummary>{
    return this.httpClient.get<CartSummary>(this.baseUrl+"/peek");
  }

  checkout(checkoutRequest: CheckoutRequest): Observable<CartResponse>{
    return this.httpClient.post<CartResponse>(this.baseUrl + "/checkout", checkoutRequest);
  }

  getOrder(orderId: string): Observable<CartResponse> {
    return this.httpClient.get<CartResponse>("/selfcare/orders/".concat(orderId));
  } 

  saveCartPayLater(orderId: string): Observable<CartResponse> {
    return this.httpClient.patch<CartResponse>("/selfcare/orders/".concat(orderId), {}); 
  }
}
